import theme from 'theme';

export const linkSx = {
  color: theme.palette.link.main,
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.action.hoverDark
  }
};

export const breadCrumbLinkSx = {
  color: theme.palette.link.main,
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.action.hoverDark
  },
  fontSize: `${theme.typography.fontSize}px`
};

export const buttonLinkSx = {
  textDecoration: 'none',
  color: theme.palette.primary.main,
  '&:hover': {
    color: theme.palette.action.hoverDark
  }
};
